const CNPJ_LENGTH = 14;
const SEPARATORS: Readonly<Record<number, string>> = { 2: '.', 5: '.', 8: '/', 12: '-' };

/** Remove máscara e normaliza para maiúsculas (até 14 caracteres alfanuméricos). */
export function unmaskCnpj(value: string): string {
  return value
    .toUpperCase()
    .replace(/[^0-9A-Z]/g, '')
    .slice(0, CNPJ_LENGTH);
}

/** Aplica a máscara `XX.XXX.XXX/XXXX-XX` progressivamente, aceitando letras (CNPJ alfanumérico). */
export function maskCnpj(value: string): string {
  const unmasked = unmaskCnpj(value);
  let masked = '';
  for (let index = 0; index < unmasked.length; index += 1) {
    masked += `${SEPARATORS[index] ?? ''}${unmasked.charAt(index)}`;
  }
  return masked;
}
